<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Tender Table</h6>
      </div>
      <hr />
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Website
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Detail
                </th>
                <th
                  class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                  Remark
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tender,index) in this.tender" :key="index">
                <td>
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <a :href="tender.website" target="_blank" class="text-danger font-weight-bold mb-0">{{ tender.websitename }}</a>
                      <a class="text-xs font-weight-bold mb-0" target="_blank" :href="tender.website">{{ tender.website }}</a>
                    </div>
                  </div>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ tender.company }}</h6>
                  <h6 class="text-xs font-weight-bold mb-0">{{ tender.contact }}</h6>
                  <h6 class="text-xs font-weight-bold mb-0">{{ tender.email }}</h6>
                </td>
                <td>
                  <h6 class="text-xs font-weight-bold mb-0">{{ tender.remark }}</h6>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>

  
<script>
import axios from 'axios';

export default {
  name:'tenderSelect',
  data(){
    return {
      tender: [],
    }
  },
  mounted(){
    this.getAllTenderWebsiteList();
  },
  methods: {
    getAllTenderWebsiteList(){
        axios.get('tender/listAllTenderWebsite')
            .then(res => {
              this.tender = res.data.tenderwebsitelist;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  